const customerConstants = {
  GET_CUSTOMERS: 'GET_CUSTOMERS',
  GET_CUSTOMERS_SUCCESS: 'GET_CUSTOMERS_SUCCESS',
  GET_CUSTOMERS_FAILURE: 'GET_CUSTOMERS_FAILURE',

  SEARCH_CUSTOMERS: 'SEARCH_CUSTOMERS',
  SEARCH_CUSTOMERS_SUCCESS: 'SEARCH_CUSTOMERS_SUCCESS',
  SEARCH_CUSTOMERS_FAILURE: 'SEARCH_CUSTOMERS_FAILURE',

  SET_SELECTED_USER: 'SET_SELECTED_USER',

  GET_LOGLINES: 'GET_LOGLINES',
  GET_LOGLINES_SUCCESS: 'GET_LOGLINES_SUCCESS',
  GET_LOGLINES_FAILURE: 'GET_LOGLINES_FAILURE',

  SET_SELECTED_LOGLINE: 'SET_SELECTED_LOGLINE',
};

export default customerConstants;
